import { useMutation, useQuery } from '@tanstack/react-query'
import { Visitor } from 'api/dto/visitor'
import { Exhibitor } from 'api/dto/exhibitor'
import axios, { AxiosResponse } from 'axios'
import { environment } from 'config/environment'

export interface SendEmailResult {
  email: string
  success: boolean
  error?: string
}

export interface SendPreRegisterEmailsResponse {
  message: string
  successCount: number
  failureCount: number
  totalCount: number
  failures?: SendEmailResult[]
}

export function useEligibleRecipients(sourceTradeShowId?: string, targetTradeShowId?: string) {
  return useQuery(
    ['eligible-recipients', sourceTradeShowId, targetTradeShowId],
    async () => {
      const { data } = await axios.get<Array<Visitor | Exhibitor>>(
        `${environment.restApi.resourceUrl.tradeshows}/${targetTradeShowId}/pre-register/eligible?sourceTradeShowId=${sourceTradeShowId}`,
      )
      return data
    },
    {
      enabled: sourceTradeShowId != null && targetTradeShowId != null,
    },
  )
}

export function useSendTestEmail(targetTradeShowId: string) {
  return useMutation<AxiosResponse<{ message: string }>, any, { testEmail: string; firstName?: string; lastName?: string; companyName?: string }, any>({
    mutationFn: async (data) => {
      return axios.post(`${environment.restApi.resourceUrl.tradeshows}/${targetTradeShowId}/pre-register/test`, data)
    },
  })
}

export function useSendPreRegisterEmails(targetTradeShowId: string) {
  return useMutation<AxiosResponse<SendPreRegisterEmailsResponse>, any, { sourceTradeShowId: string; recipientEmails: string[] }, any>({
    mutationFn: async (data) => {
      return axios.post(`${environment.restApi.resourceUrl.tradeshows}/${targetTradeShowId}/pre-register/send`, data)
    },
  })
}
